import { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { requestPasswordReset } from "../api/auth";
import {
  BADGE_STYLES,
  BUTTON_STYLES,
  CARD_STYLES,
  INPUT_STYLES,
  TEXT_STYLES,
} from "../components/ui/CamberTheme";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [formError, setFormError] = useState("");

  const resetMutation = useMutation({
    mutationFn: requestPasswordReset,
    onSuccess: ({ data }) => {
      setFormError("");
      setMessage(data?.detail || "If that email exists, password reset instructions have been sent.");
    },
    onError: (err) => {
      setMessage("");
      const detail = err.response?.data?.email?.[0] || err.response?.data?.detail || "Could not request password reset.";
      setFormError(detail);
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setMessage("");
    setFormError("");
    resetMutation.mutate({ email });
  };

  return (
    <div
      className={`min-h-screen ${CARD_STYLES.page} flex items-center justify-center p-4`}
      style={{ fontFamily: "'Open Sans', sans-serif" }}
    >
      <form onSubmit={handleSubmit} className={`w-full max-w-md ${CARD_STYLES.surfaceBordered} p-8`}>
        <div className="text-center mb-8">
          <img src="/camber.png" alt="Camber" className="h-10 w-auto mx-auto mb-4" />
          <h1 className={`${TEXT_STYLES.title} text-[20px]`}>Reset Password</h1>
          <p className={`mt-2 text-[12px] leading-[155%] ${TEXT_STYLES.muted}`}>
            Enter your account email and we will send reset instructions.
          </p>
        </div>

        <div>
          <label className={`block mb-2 text-[12px] ${TEXT_STYLES.label}`}>Email</label>
          <input
            className={INPUT_STYLES.base}
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <button
          type="submit"
          disabled={resetMutation.isLoading}
          className={`w-full mt-6 py-2 ${BUTTON_STYLES.primary} disabled:opacity-50`}
        >
          {resetMutation.isLoading ? "Sending..." : "Send Reset Link"}
        </button>

        <Link to="/login" className="block mt-4 text-center text-[12px] leading-[155%] text-[#5937D6] hover:underline">
          Back to login
        </Link>

        {message && (
          <div className="mt-4 p-3 rounded-[4px] bg-camber-successBg border border-camber-border">
            <p className={`text-sm ${BADGE_STYLES.success}`}>{message}</p>
          </div>
        )}

        {formError && (
          <div className="mt-4 p-3 rounded-[4px] bg-camber-dangerBg border border-camber-border">
            <p className={`text-sm ${BADGE_STYLES.danger}`}>{formError}</p>
          </div>
        )}
      </form>
    </div>
  );
}
